import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
require('../../styles/FormItemRender.css');
export default class FormItemStringRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}

	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		if(_value == true || _value ==  false){
			_value = _value+"";
		}
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{_value}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemStringRenderForAutoLookup.js